import { observer } from 'mobx-react-lite';
import VideoCardList from '../widgets/VideoCardList/VideoCardList';
import MetaTags from '../components/MetaTags/MetaTags';
import JsonLd from '../components/JsonLd/JsonLd';
import LanguageStore from '../store/LanguageStore';
import { createWebsiteSchema } from '../utils/jsonLdSchemas';
import '../styles/layout.scss';
import Filters from '../widgets/Filters/Filters';

const HomePage = observer(() => {
    const { language } = LanguageStore;
    const siteUrl = window.location.origin;
    
    // Создаем JSON-LD схему для главной страницы
    const websiteSchema = createWebsiteSchema(
        language === 'ru' ? 'Видео статистика' : 'Video Statistics',
        siteUrl,
        language === 'ru' 
            ? 'Аналитика и статистика трендовых видео на YouTube'
            : 'Analytics and statistics of trending YouTube videos',
        language
    );

    return (
        <article className="container">
            <MetaTags/>
            <JsonLd data={websiteSchema} id="json-ld-website" />
            <Filters/>
            <VideoCardList/>
        </article>
    );
});

export default HomePage;